import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useCashPaymentStatus from '@api/hooks/payments/useCashPaymentStatus';
import { CASH_ORDER_STATUS } from '@cont/Checkout/utils';
import redirect from '@cont/App/redirect';
import useSelectedGoal from '@api/hooks/topology/useSelectedGoal';

const useHandleCashPayment = () => {
  const { query } = useRouter();

  const { selectedGoal } = useSelectedGoal();

  const gUID = query.goalUID || selectedGoal?.uid;

  const { cashResponse, isError: fetchError } = useCashPaymentStatus(gUID);

  useEffect(() => {
    if (!fetchError && cashResponse) {
      if (cashResponse.cashPaymentState === CASH_ORDER_STATUS.PAID) {
        const goalDetails =
          cashResponse.userSubscriptionDetails?.userSubscription?.subscription
            .value;
        redirect(false, {
          href: '/goal/[goalSlug]/[goalUID]/subscribe/thank-you',
          as: `${goalDetails.relativeLink}/subscribe/thank-you?mode=cash`,
          query: { mode: 'cash' }
        });
      }
    }
  }, [cashResponse, fetchError]);
};

export default useHandleCashPayment;
